import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormKeys } from '@nx-customer-apps/shared/enums';
import { FormOptions } from '@nx-customer-apps/shared/interfaces';
import { RadioQuestion } from '@nx-customer-apps/shared/utils';

@Injectable({
    providedIn: 'root'
})
export class VentilationFormService {
    public getVentilationQuestions(options?: FormOptions): RadioQuestion[] {
        return this.getVentilation(options);
    }

    private getVentilation(options?: FormOptions): RadioQuestion[] {
        return [
            new RadioQuestion({
                question: 'HEATLOAD.VENTILATION.VENTILATION.TITLE',
                key: FormKeys.Ventilation,
                styles: 'ca-radio-columns',
                defaultErrorMessage: 'Please provide ventilation method',
                validators: [Validators.required],
                options: [
                    { key: 'HEATLOAD.VENTILATION.VENTILATION.YES', value: true },
                    { key: 'HEATLOAD.VENTILATION.VENTILATION.NO', value: false }
                ],
                value: options?.questions?.[FormKeys.Ventilation]?.value
            })
        ];
    }
}
